import { CommonUtilsService } from 'util/util';
import { ProgressMessageOptions, ToastMessage } from '../domain';
import { DEFAULT_DELAY, ToastMessageQueueService } from './toastMessageQueueService';

const DEFAULT_POSITION = 'bottom right';
var toastPromise = null;

const getDelay = (delay: number) => typeof delay === 'number' && delay > 0 ? delay : DEFAULT_DELAY;

import * as toastComponent from '../components/toastMessage/toastMessage';

/**
 * Post notification messages in ShareBase
 */
export class ToastService {
	public static readonly $inject = [
		'$timeout',
		'$mdToast',
		'utils',
		'sbToastMessageQueueService',
		'gettextCatalog'
	];

	/**
	 * App wide default hide delay
	 */
	public get defaultDelay() { return DEFAULT_DELAY; }

	/**
	 * App wide default notification position
	 */
	public get defaultPosition() { return DEFAULT_POSITION; }

	constructor(
		private readonly $timeout: ng.ITimeoutService,
		private readonly $mdToast,
		private readonly utils: CommonUtilsService,
		private readonly queue: ToastMessageQueueService,
		private readonly gettextCatalog
	) {
		this.queue.onEmpty(() => this.hideToastIfNoMessages());
	}

	/**
	 * Show a basic message that will be hidden after the delay expires
	 * 
	 * @param message The message to show
	 * @param delay An optional delay to override the default delay
	 */
	public showSimple(message: string, delay?: number) {
		this.displayToast(delay);

		this.queue.addSimple(message, delay);
	}

	/**
	 * Shows a simple toast message with an action
	 * 
	 * @param message The message to show
	 * @param actionName The name of the action to display
	 * @param action A function that gets executed if the user clicks on the action button	
	 * @param delay An optional delay to override the default delay
	 */
	public showSimpleAction(message: string, actionTooltip: string, action: () => void, delay?: number | string, actionIcon?: string) {
		this.displayToast();

		let hideDelay: number;
		if (typeof delay === 'number') {
			hideDelay = delay;
			actionIcon = actionIcon || 'done';
		} else {
			hideDelay = DEFAULT_DELAY;
			actionIcon = delay;
		}

		this.queue.addAction(message, {
			fn: action,
			tooltip: actionTooltip,
			icon: actionIcon
		}, hideDelay);
	}

	/**
	 * Show a long lived toast message with an optional action and progress measure.
	 * 
	 * @param message Toast message
	 * @param opts Additional toast options
	 */
	public showProgressMessage(opts: ProgressMessageOptions) {
		this.displayToast();
		return this.queue.addProgress(opts);
	}

	private displayToast(hideDelay = 0) {
		if (this.queue.total === 0) {
			let opts = {
				template: toastComponent.template,
				controller: toastComponent.ToastMessageController,
				controllerAs: 'vm',
				hideDelay: hideDelay,
				bindToController: true,
				position: DEFAULT_POSITION,
				toastClass: 'sb-toast-notifications'
			}
	
			// enables smoother animation
			this.$timeout(() => this.$mdToast.show(opts), 0);
		}
	}

	private hideToastIfNoMessages() {
		if (this.queue.total === 0) {
			this.$mdToast.hide();
		}
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/services/toastService.ts